import { render } from "./colorMapSelector.vue?vue&type=template&id=1319475b&ts=true"
import script from "./colorMapSelector.vue?vue&type=script&lang=ts"
export * from "./colorMapSelector.vue?vue&type=script&lang=ts"

import "./colorMapSelector.vue?vue&type=style&index=0&id=1319475b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__